import { IIssuerModel } from './issuerModel';
import { IRoleModel } from './roleModel';
import { IOrganizationStep3FormResultKeys } from '../../components/registration/organization/step3/organizationStep3FormModel';
import {
    IProfessionalStep2FormResultModel,
    ProfessionalStep2FormResultKeys,
} from '../../components/registration/professional/step2/professionalStep2FormModel';

export interface IProviderModel {
    id: string;
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    ext: string;
    role: number | IRoleModel;
    issuer: number | IIssuerModel;
    licenceNumber: string;
    licenceDate: string;
    lng: string;
    comment: string;
    sameContact: boolean;
    access: boolean;
    openServices: boolean;
    businessNumber: string;
    gstHst: string;
    rt: string;
    businessComment: string;
}

export class ProviderModel {
    public id: string | undefined;
    public firstname: string | undefined;
    public lastname: string | undefined;
    public email: string | undefined;
    public phone: string | undefined;
    public ext: string | undefined;
    public role: number | undefined;
    public issuer: number | undefined;
    public licenceNumber: string | undefined;
    public licenceDate: string | undefined;
    public lng: string | undefined;
    public comment: string | undefined;
    public sameContact: boolean | undefined;
    public access: boolean | undefined;
    public openServices: boolean | undefined;
    public businessNumber: string | undefined;
    public gstHst: string | undefined;
    public rt: string | undefined;
    public businessComment: string | undefined;
}

export const providerModelFromFormData = (
    formData: IOrganizationStep3FormResultKeys | IProfessionalStep2FormResultModel
): IProviderModel => {
    if (formData.hasOwnProperty(ProfessionalStep2FormResultKeys.FIRST_NAME)) {
        const data = formData as IProfessionalStep2FormResultModel;
        return {
            firstname: data.form_professional_step_2_field_first_name,
            lastname: data.form_professional_step_2_field_last_name,
            role: Number(data.form_professional_step_2_field_profession),
            phone: data.form_professional_step_2_field_phone ?? '',
            ext: data.form_professional_step_2_field_phone_ext ?? '',
            email: data.form_professional_step_2_field_email,
            issuer: Number(data.form_professional_step_2_field_issuer),
            licenceNumber: data.form_professional_step_2_field_number,
            licenceDate: data.form_professional_step_2_field_issue_date,
            businessNumber: data.form_professional_step_2_field_enterprise_number,
            gstHst: data.form_professional_step_2_field_enterprise_tps,
            rt: data.form_professional_step_2_field_enterprise_rt,
            comment: data.form_professional_step_2_field_comment,
            sameContact: true,
            access: true,
            openServices: false,
            businessComment: '',
        } as IProviderModel;
    } else {
        const data = formData as IOrganizationStep3FormResultKeys;
        return {
            firstname: data.form_organization_step_3_field_first_name,
            lastname: data.form_organization_step_3_field_last_name,
            role: data.form_organization_step_3_field_profession,
            email: data.form_organization_step_3_field_email,
            issuer: data.form_organization_step_3_field_issuer,
            licenceNumber: data.form_organization_step_3_field_number,
            licenceDate: data.form_organization_step_3_field_issue_date,
            comment: data.form_organization_step_3_field_comment,
            phone: '',
            ext: '',
            businessNumber: '',
            gstHst: '',
            rt: '',
            sameContact: true,
            access: true,
            openServices: false,
            businessComment: '',
        } as IProviderModel;
    }
};
